const getAttr = (obj, key) => (
  obj.currentStyle
    ? obj.currentStyle[key]
    : window.getComputedStyle(obj, false)[key]
)
const drag = {
  inserted (el) {
    // 拖拽的弹窗头部
    const header = el.querySelector('.card_header-buttons_qyTyG')
    // 拖拽的弹窗内容
    const target = el.querySelector('.card_card-container_3IqIB')
    // 鼠标手型
    header.style.cursor = 'move'
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null)
    // const sty = target.currentStyle || window.getComputedStyle(target, null)
    header.onmousedown = (e) => {
      const currentX = e.clientX
      const currentY = e.clientY
      const left = parseInt(getAttr(target, 'left'))
      const top = parseInt(getAttr(target, 'top'))
      const minLeft = target.offsetLeft + parseInt(getAttr(target, 'width'))*2
      const maxLeft = parseInt(getAttr(document.body, 'width')) - target.offsetLeft -parseInt(getAttr(target, 'width'))
      const minTop = target.offsetTop+50
      const maxTop = parseInt(getAttr(document.body, 'height')) - target.offsetTop - parseInt(getAttr(header, 'height'))-130
      // todo 计算一下 bottom
      document.onmousemove = (event) => {
        // 鼠标移动时计算每次移动的距离，并改变拖拽元素的定位
        const disX = event.clientX - currentX
        const disY = event.clientY - currentY
        // 判断左、右边界
        if (disX < 0 && disX <= -minLeft) {
          target.style.left = `${left - minLeft}px`
        } else if (disX > 0 && disX >= maxLeft) {
          target.style.left = `${left + maxLeft}px`
        } else {
          target.style.left = `${left + disX}px`
        }
        // 判断上、下边界
        if (disY < 0 && disY <= -minTop) {
          target.style.top = `${top - minTop}px`
        } else if (disY > 0 && disY >= maxTop) {
          target.style.top = `${top + maxTop}px`
        } else {
          target.style.top = `${top + disY}px`
        }
        // 阻止事件的默认行为，可以解决选中文本的时候拖不动
        return false
      }
      // 鼠标松开时，拖拽结束
      document.onmouseup = () => {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  },
  // 每次重新打开 dialog 时，要将其还原
  update (el) {
    const target = el.children[0]
    target.style.left = ''
    target.style.top = ''
  },
  // 最后卸载时，清除事件绑定
  unbind (el) {
    const header = el.querySelector('.dialog-header')
    header.onmousedown = null
  }
}
export default drag



// WEBPACK FOOTER //
// ./src/directives/drag/drag.js